angular.module('aq.filters.arrays').filter('contains', function() {
    return function(data, finder) {
        return _.includes(data, finder);
    }
});